import { memo } from 'react';
import Link from 'next/link';
import { URL } from '@/common/app/utils/urlsUtils';
import { CommonPageType, ICommonItem } from '../../../domain/CommonPage.domain';
import { getFormattedDate } from '@/entities/Blogs/app/getFormattedDate';
import { CardImage } from './cardItem/CardImage/CardImage';
import * as S from './CardItem.styles';

type CardItemProps = {
    type: CommonPageType;
    item: ICommonItem;
};

const CardItemContainer = ({ type, item }: CardItemProps) => {
    const { slug, title, image, category, updated_at } = item;

    const slugUrl = type;
    const cardLink = `/${slugUrl}/${slug}/`;
    const imageSrc = `${URL.image}/${type}/${image.id}/700x600/${image.slug}.jpg`;
    const location = category?.name;

    return (
        <Link href={cardLink.toLowerCase()} passHref>
            <S.Container>
                <CardImage imageSrc={imageSrc} title={title} />
                <S.Content>
                    {!!updated_at && <S.Date>{getFormattedDate(updated_at)}</S.Date>}
                    <S.Title>{title}</S.Title>
                    <S.Location>
                        <S.LocationImg />
                        <S.LocationCity>{location}</S.LocationCity>
                    </S.Location>
                </S.Content>
            </S.Container>
        </Link>
    );
};

export const CardItem = memo(CardItemContainer);
